module.exports = __webpack_public_path__ + "img/box.d4f92fe6.png";